import type { ServerConfig } from 'shared-types';

type Params = {
  relative?: boolean;
  serverConfig: Pick<
    ServerConfig,
    'hideAchievementsFromUI' | 'hideCoursesFromUI' | 'hidePathsFromUI'
  >;
};

/**
 * Returns the first available My Team Review destination.
 * Use `relative: true` for MyTeamPage `activeLink` (`/my-team${activeLink}`).
 */
const getMyTeamReviewHref = ({
  relative = false,
  serverConfig
}: Params): string => {
  const achievementsVisible = !serverConfig.hideAchievementsFromUI;
  const coursesVisible = !serverConfig.hideCoursesFromUI;
  const pathsVisible = !serverConfig.hidePathsFromUI;

  let href = '/my-team';

  if (coursesVisible || achievementsVisible) {
    href += '/review/expiring-completions';
  } else if (coursesVisible || pathsVisible) {
    href += '/review/upcoming-target-schedules';
  }

  if (relative) return href.replace(/^\/my-team/, '') || '';
  return href;
};

export default getMyTeamReviewHref;
